import { StandardEvents } from '@shopify/events';
import { clearAllCartLines } from '@theme/uucck-cart-clear-all';

/** @returns {HTMLElement | null} */
function getWrap() {
  return document.querySelector('[data-uucck-cart-page-clear-all-wrap]');
}

/** @param {boolean} show */
function setWrapVisible(show) {
  const wrap = getWrap();
  if (!wrap) return;
  wrap.hidden = !show;
}

/** @param {number} itemCount */
function syncVisibility(itemCount) {
  setWrapVisible(itemCount > 0);
}

/** @param {import('@shopify/events').CartLinesUpdateEvent} event */
function onCartUpdate(event) {
  event.promise
    ?.then(({ cart, detail }) => {
      const itemCount = cart?.totalQuantity ?? detail?.itemCount;
      if (itemCount !== undefined) syncVisibility(itemCount);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[uucck-cart-page-clear-all] Event promise rejected:', error);
      }
    });
}

/** @param {MouseEvent} event */
function onDocumentClick(event) {
  const button =
    event.target instanceof Element ? event.target.closest('[data-uucck-cart-page-clear]') : null;
  if (!button || button.disabled) return;
  event.preventDefault();
  clearAllCartLines(/** @type {HTMLButtonElement} */ (button), {
    source: 'uucck-cart-page-clear-all',
  });
}

document.addEventListener(StandardEvents.cartLinesUpdate, onCartUpdate);
document.addEventListener('click', onDocumentClick);
